import type { SubagentPhaseGroup } from "@/lib/subagent-tasks";
import { SubagentSectionToggle } from "./SubagentSectionHeader";
import { SubagentTaskCardList } from "./SubagentTaskCard";
import { useSectionCollapse } from "./useSectionCollapse";

/** run_subagent が phase 付きで起動した run のフェーズ 1 つ。開閉付きで run を並べる。 */
export function SubagentPhaseSection({
	phase,
	selectedId,
	onSelect,
}: {
	phase: SubagentPhaseGroup;
	selectedId: string | null;
	onSelect: (id: string) => void;
}) {
	const containsSelected = phase.runs.some((run) => run.id === selectedId);
	const [collapsed, toggle] = useSectionCollapse(
		!(phase.hasActive || containsSelected),
		containsSelected ? selectedId : null,
		phase.hasActive,
	);

	return (
		<section data-testid="subagent-phase-section" data-phase={phase.title}>
			<SubagentSectionToggle
				testId="subagent-phase-toggle"
				label={phase.title}
				count={`${phase.completed}/${phase.total}`}
				countFailure={phase.hasFailure}
				collapsed={collapsed}
				onToggle={toggle}
			/>
			{!collapsed && (
				<SubagentTaskCardList runs={phase.runs} selectedId={selectedId} onSelect={onSelect} />
			)}
		</section>
	);
}
